import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import Translate, { translate } from 'react-translate-component';
import PropTypes from 'prop-types';
import { Row, Col, message } from 'antd';
import { prop } from 'ramda';

import { getCourseList, putEnrollCourse } from 'actions/asyncActions';
import { fullAutoOptions } from 'constants/asyncClient';
import { courses } from 'constants/routes';
import StaticTable from 'components/common/tableComponents/StaticTable';
import { TabsStatusFilter } from 'components/common/controls/TabsStatusFilter';
import { SidebarLink, CheckboxCell } from 'components/common/tableComponents/cellTemplates';
import { COURSE_SIDEBAR } from 'constants/sidebarTypes';
import { getStatusPayload, setFilter } from 'helpers/filterHelpers';
import RefreshButton from 'components/common/controls/RefreshButton';
import YesNoField from 'components/common/fields/YesNoField';
import { defaultCourseListFilters } from 'constants/defaultFilters';
import CourseButton from './CourseButton';
import ErrorHTML from 'components/common/form/ErrorHTML';

@withAsyncActions({
    getCourseList: getCourseList
        .withPayload(props => setFilter(
            prop('status', getStatusPayload(props)),
            defaultCourseListFilters
        ))
        .withOptions(fullAutoOptions),
    putEnrollCourse: putEnrollCourse
        .withSuccessHandler(({ getCourseList: { refresh }, setSelected }) => {
            refresh();
            setSelected([]);
            message.success(translate('education.courses.enrollSuccess'), 2);
    })
})
export default class CourseListTable extends Component {
    static propTypes = {
        getCourseList: PropTypes.object.isRequired,
        putEnrollCourse: PropTypes.object.isRequired,
        onSelect: PropTypes.func.isRequired,
        selected: PropTypes.array
    }

    tableColumns = [
        {
            name: 'checkbox',
            width: 50,
            template: ({ item }) => (
                <CheckboxCell
                    selected={this.props.selected}
                    setSelected={this.props.onSelect}
                    item={item}
                    rowIndex={item.id}
                />
            ),
        },
        {
            name: 'number',
            width: 40,
            template: ({ rowIndex }) => rowIndex + 1,
        },
        {
            name: 'name',
            label: <Translate content="education.courses.headers.name" />,
            template: ({ item }) => <SidebarLink
                componentName={COURSE_SIDEBAR}
                item={item}
                value={item.name}
            />
        },
        {
            name: 'type',
            label: <Translate content="education.courses.type" />,
            template: ({ item: { type } }) => <Translate content={`education.courses.typeNumber.${type}`} />
        },
        {
            name: 'isIndividual',
            width: 200,
            label: <Translate content="education.courses.headers.isIndividual" />,
            template: ({ item: { isIndividual } }) => <YesNoField value={isIndividual} />
        },
        {
            name: 'needApproval',
            width: 200,
            label: <Translate content="education.courses.headers.needApproval" />,
            template: ({ item: { needApproval } }) => <YesNoField value={needApproval} />
        }
    ]

    render() {
        const { data, meta, refresh } = this.props.getCourseList;
        const { selected } = this.props;

        return (
            <div className="course-list-table">
                <Row className='react-table-controls'>
                    <Col span={6}>
                        <CourseButton selected={selected} courseList={data.list} />
                    </Col>
                    <Col span={18}>
                        <ErrorHTML meta={this.props.putEnrollCourse.meta} className="course-list-error"/>
                    </Col>
                </Row>
                <Row className="react-table-controls list-controls">
                    <Col span={18}>
                        <TabsStatusFilter
                            route={courses}
                            defaultFilters={defaultCourseListFilters}
                            translate='courses'
                        />
                    </Col>
                    <Col span={6} className="text-right icon-bar">
                        <RefreshButton refreshMeta={meta} handleRefresh={refresh} />
                    </Col>
                </Row>
                <div>
                    <StaticTable
                        meta={meta}
                        refresh={refresh}
                        className="width-auto-table"
                        columns={this.tableColumns}
                        items={data.list}
                    />
                </div>
            </div>
        )
    }
}
